import React, { type JSX } from 'react'

import { PropsWithClassName } from '@helper/PropsWithClassName'
import { cn } from '@helper/utils/cn'

import { Root } from './Row.styles'

interface Props extends PropsWithClassName {
  children?: JSX.Element | JSX.Element[]
  dataTestId?: string
}

const Row = (props: Props): JSX.Element => {
  const { className, children, dataTestId } = props
  return (
    <Root
      className={cn(className, 'row')}
      data-testid={dataTestId ?? 'Row-root'}
    >
      {children}
    </Root>
  )
}

export { Row }
